import React from "react";
import { useEffect, useState } from "react";
import Input from "./Input";

export default function ClientTypeSelector(props) {
  useEffect(() => {
    window.M.updateTextFields();
  }, [props.value.type]);

  const SetValue = (field, value) => {
    if (typeof value === "string") {
      let searchItem = null
      value = value.replaceAll('«', '"')
      value = value.replaceAll('»', '"')
      for (let i = 0; i < value.length; i++) {
        searchItem = value.indexOf('"')
        if (searchItem === -1) {
          break
        }
        if (searchItem + 1 !== value.length && value.charAt(searchItem+1)?.toLowerCase() !== value.charAt(searchItem+1)) {
          value = value.replace(/"/, '«')
        } else{
          value = value.replace(/"/, '»')
        }

      }
    }
    props.SetValue("clientType", { ...props.value, [field]: value });
  };
  let FormDraw = () => {
    return <div></div>;
  };
  if (props.value.type === "ф.л.") {
    FormDraw = () => {
      return (
        <div>
          <Input
            id="fio"
            type="text"
            caption="ФИО"
            SetValue={SetValue}
            field="fio"
            value={props.value.fio}
          />
          <Input
            id="otherdetails"
            type="text"
            caption="Прочие данные"
            SetValue={SetValue}
            field="otherDetails"
            value={props.value.otherDetails}
          />
        </div>
      );
    };
  }
  if (props.value.type === "ю.л.") {
    FormDraw = () => {
        let FormOfpDraw = () => {
            return <div></div>;
        };
        if (props.value.ofp === "Иное") {
            FormOfpDraw = () => {
                return(
              <div>
                <Input
                  id="fullofp"
                  type="text"
                  caption="Наименование ОФП"
                  SetValue={SetValue}
                  field="fullofp"
                  value={props.value.fullofp}
                />
                <Input
                  id="shortofp"
                  type="text"
                  caption="Короткое наименование ОФП"
                  SetValue={SetValue}
                  field="shortofp"
                  value={props.value.shortofp}
                />
              </div>)
            };
          }
      return (
        <div>
          <div className="input-field">
            <div>
              <label>ОФП</label>
            </div>
            <select
              id="selectofp"
              className="browser-default"
              onChange={(e) => {
                props.SetValue("clientType", {
                  ...props.value,
                  ofp: e.target.value,
                });
              }}
            >
              <option
                value=""
                disabled
                selected={props.value.ofp == "" ? true : false}
              >
                ...
              </option>
              <option
                value="ООО"
                selected={props.value.ofp == "ООО" ? true : false}
              >
                Общество с ограниченной ответственностью (ООО)
              </option>
              <option
                value="АО"
                selected={props.value.ofp == "АО" ? true : false}
              >
                Акционерное общество (АО)
              </option>
              <option
                value="ИП"
                selected={props.value.ofp == "ИП" ? true : false}
              >
                Индивидуальный предприниматель (ИП)
              </option>
              <option
                value="Иное"
                selected={props.value.ofp == "Иное" ? true : false}
              >
                Иное
              </option>
            </select>
          </div>
          {FormOfpDraw()}
          <Input
            id="name"
            type="text"
            caption="Наименование"
            SetValue={SetValue}
            field="name"
            value={props.value.name}
          />
          <Input
            id="shortname"
            type="text"
            caption="Сокращенное наименование"
            SetValue={SetValue}
            field="shortname"
            value={props.value.shortname}
          />
          <Input
            id="inface"
            type="text"
            caption="В лице"
            SetValue={SetValue}
            field="inface"
            value={props.value.inface}
          />
          {/* <Input
            id="doljnost"
            type="text"
            caption="Должность"
            SetValue={SetValue}
            field="doljnost"
            value={props.value.doljnost}
          /> */}
          {/* <Input
            id="actions"
            type="text"
            caption="Действующего на основании"
            SetValue={SetValue}
            field="actions"
            value={props.value.actions}
          /> */}
          <Input
            id="family"
            type="text"
            caption="Фамилия и инициалы"
            SetValue={SetValue}
            field="family"
            value={props.value.family}
          />
          <Input
            id="inn"
            type="text"
            caption="ИНН"
            SetValue={SetValue}
            field="inn"
            value={props.value.inn}
          />
          <Input
            id="ogrn"
            type="text"
            caption="ОГРН"
            SetValue={SetValue}
            field="ogrn"
            value={props.value.ogrn}
          />
        </div>
      );
    };
  }
  return (
    <div>
      <div className="input-field">
        <div>
          <label>Клиент</label>
        </div>
        <select
          id="selectClient"
          className="browser-default"
          onChange={(e) => {
            props.SetValue("clientType", {
              ...props.value,
              type: e.target.value,
            });
          }}
        >
          <option
            value=""
            disabled
            selected={props.value.type == "" ? true : false}
          >
            ...
          </option>
          <option
            value="ф.л."
            selected={props.value.type == "ф.л." ? true : false}
          >
            Клиент-физическое лицо (ф.л.)
          </option>
          <option
            value="ю.л."
            selected={props.value.type == "ю.л." ? true : false}
          >
            Клиент-юридическое лицо (ю.л.)
          </option>
        </select>
      </div>
      {FormDraw()}
    </div>
  );
}
